import logo from './logo.svg';
import './App.css';
import {useEffect} from "react";

function App() {
  // eslint-disable-next-line no-undef
  const ps = context.env.DB.prepare('SELECT * from users');
  useEffect(()=>{

    async function fetchData() {
      const data = await ps.first();
      console.log(data);
    }

    fetchData();

  },[]);

  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>
    </div>
  );
}

export default App;
